<template>
  <v-container fluid class="grey lighten-4">
    <v-layout mt-10>
      <v-flex xs12>
        <h1 class="display-3 font-weight-bold text-center text-uppercase">EDU Blog</h1>
        <h3 class="subtitle font-weight-light text-center mt-5">Únete a la comunidad vizcaya.</h3>
        <v-item-group v-model="toggle_exclusive">
          <v-container>
            <v-row class="justify-center align-center">
              <v-col v-for="(item, index) in options" :key="index" cols="6" sm="12" md="2" lg="2">
                <v-item v-slot:default="{ active, toggle }" :value="item.value">
                  <v-card
                    flat
                    tile
                    class="d-flex align-center transparent"
                    :class="{ 'card-selected': active }"
                    height="50"
                    @click="toggle"
                  >
                    <v-card-text>
                      <h3
                        class="text-center"
                        :class="{ 'blue--text text--darken-4': active }"
                      >{{item.text}}</h3>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
        <v-container fluid grid-list-xl>
          <v-row mx-12>
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="4"
              v-for="(item, index) in tagsFiltered"
              :key="index"
            >
              <v-card color="transparent" flat tile>
                <v-img class="white--text" height="250px" :src="publicPath+item.picture">
                  <v-chip label color="black" dark class="text-uppercase absolute">{{item.tag}}</v-chip>
                </v-img>
                <v-card-text>
                  <h3
                    class="headline text-uppercase font-weight-bold text-center black--text"
                  >{{item.title}}</h3>
                  <p class="text-center black--text body-1">{{item.description}}</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style lang="scss" scoped>
.absolute {
  left: 0;
  position: absolute;
  bottom: 0;
}
.card-selected {
  border-bottom: 2px solid #141c3e !important;
}
.transparent {
  background-color: transparent;
}
</style>
<script>
import { mapState } from "vuex";
import { mask } from "vue-the-mask";
import axios from "axios";
import lodash from "lodash";
export default {
  mounted() {
    this.sendInfoData();
  },
  data() {
    return {
      toggle_exclusive: "Todos",
      publicPath: "https://www.admin-uva.tidingo.com/",
      selected: null,
      articles: [],
      posts: [
        {
          id: 0,
          title: "Balance entre el hogar y educación",
          tag: "popular",
          description:
            "Conoce nuestras recomendaciones para mantener un equilibrio entre tu familia y tu licenciatura"
        },
        {
          id: 1,
          title: "Cómo tomar notas para estudiar",
          tag: "nuevo",
          description:
            "Conoce nuestras recomendaciones para mantener un equilibrio entre tu familia y tu licenciatura"
        },
        {
          id: 2,
          title: "Experiencia: Mejoré mi negocio",
          tag: "video",
          description:
            "Conoce nuestras recomendaciones para mantener un equilibrio entre tu familia y tu licenciatura"
        }
      ],
      options: [{ text: "Todos", value: "Todos" }]
    };
  },
  methods: {
    sendInfoData() {
      var self = this;
      axios({
        method: "get",
        url:
          "https://www.admin-uva.tidingo.com/api/events-list-by-campus?webpage=Uva en línea&campus=Distancia",
        config: {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
          },
          withCredentials: true,
          credentials: "same-origin"
        }
      })
        .then(function(response) {
          //console.log(response.data.data);
          self.articles = response.data.data;
        })
        .catch(function(error) {
          //console.log(error);
        });
    }
  },
  computed: {
    tagsFiltered() {
      this.articles.map(item => {
        item.tag = "Todos";
        return item;
      });
      return this.articles.filter(item => {
        return item.tag
          .toLowerCase()
          .includes(this.toggle_exclusive.toLowerCase());
      });
    }
  }
};
</script>